import type { FundraisingResponse } from '@shared/schemas';

import {
  type FundraisingDraft,
  type LoadStatus,
  makeEmptyDraft,
  type SaveStatus,
  type ValidationErrors,
} from '../../_shared/domain/fundraising-draft.model';
import type { FundraisingFormError } from '../../_shared/domain/fundraising-form-error';

/**
 * Redux state for the Edit-fundraising form. Beyond the shared draft + save
 * lifecycle, Edit tracks the loaded round (source of the id for the PATCH) and
 * the load lifecycle. Every field is serialisable.
 */
export interface EditFundraisingState {
  /** The round being edited (null until loaded). */
  fundraising: FundraisingResponse | null;
  draft: FundraisingDraft;
  loadStatus: LoadStatus;
  saveStatus: SaveStatus;
  validationErrors: ValidationErrors;
  error: FundraisingFormError | null;
  /** Deleting a round: its own lifecycle, so a failed delete never reads as a failed save. */
  deleteStatus: SaveStatus;
  deleteError: FundraisingFormError | null;
  /** Undoing an update. */
  revertStatus: SaveStatus;
}

/**
 * Factory (not a const): the placeholder draft defaults to the current
 * month/year (it is replaced by the loaded round on hydration).
 */
export function makeInitialState(): EditFundraisingState {
  return {
    fundraising: null,
    draft: makeEmptyDraft(),
    loadStatus: 'idle',
    saveStatus: 'idle',
    validationErrors: {},
    error: null,
    deleteStatus: 'idle',
    deleteError: null,
    revertStatus: 'idle',
  };
}
